<div class="modal-header">
  <h4 class="modal-title" id="modal-title">{{options.title}}</h4>
  <button type="button" class="close" aria-describedby="modal-title" tabindex="-1" (click)="zamknij('dismiss')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form name="form" role="form" style="margin-top: 10px;">
    <formly-validation-message></formly-validation-message>
    <formly-form [model]="form.model" [fields]="form.fields" [form]="form.form">
      <div class="float-right mt-3">
        <button type="button" class="btn btn-outline-secondary" (click)="zamknij('cancel')">{{options.cancelLabel}}</button>
        <button type="button" class="btn btn-danger ml-3" (click)="zatwierdz()">{{options.saveLabel}}</button>
      </div>
    </formly-form>
  </form>
  <div class="clearfix"></div>
</div>
